import script from "./UiIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiIcon.vue?vue&type=script&setup=true&lang=ts"

import "./UiIcon.vue?vue&type=style&index=0&id=413c59ee&lang=css"

const __exports__ = script;

export default __exports__